import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import './Cosmetictype.css';
import { ThemeContext } from '../../contexts/ThemeContext';

const BG = `${process.env.PUBLIC_URL}/assets/images/vecteezy_beauty.webp`;

function Cosmetictype() {
    const { theme } = useContext(ThemeContext);

    return (
        <div className={`cosmetic-type-container ${theme ? 'light-theme' : 'dark-theme'}`}>
            <div className="left-section">
                <img
                    src={BG}
                    alt=""
                    className="section-bg-img"
                    fetchpriority="high"
                    decoding="async"
                />
                <div className="overlay"></div>
                <Link to="/beauty" className="cosmetic-button">
                    زیبایی
                </Link>
            </div>

            <div className="right-section">
                <img
                    src={BG}
                    alt=""
                    className="section-bg-img"
                    fetchpriority="high"
                    decoding="async"
                />
                <div className="overlay"></div>
                <Link to="/cosmetics" className="biotin-button">آرایشی و بهداشتی</Link>
            </div>
        </div>
    );
}

export default Cosmetictype;
